import styled from "styled-components";

const Main = styled.main`
    grid-area: main;
    /* background-color: #faf9f8; */
    background-color: white;
    border-top: 1px solid #eee;
`;

export default Main;